"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSubscription = createSubscription;
exports.deleteSubscription = deleteSubscription;
exports.editSubscription = editSubscription;
exports.getLocations = getLocations;
exports.getSubscriptions = getSubscriptions;
var _RestHelper = _interopRequireDefault(require("../utils/RestHelper"));
var urlLocations = '/cscn-customer-srv/api/consumption/v0/locations';
var urlSubscriptions = '/cscn-customer-srv/api/consumption/v0/subscriptions';
function getLocations() {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl()).concat(urlLocations, "?activeOnly=true"));
}

/**
 * - Get a single or list of subscriptions
 * An empty list is returned if no subscriptions are found.
 */
function getSubscriptions(subscriptionId) {
  if (subscriptionId) {
    return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl()).concat(urlSubscriptions, "/").concat(subscriptionId));
  }
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl()).concat(urlSubscriptions));
}

/**
 * - Creates a new subscription
 * ️️️️️The locations available for creating a new load shape
 * subscription can be obtained using the "getLocations()" API.
 */
function createSubscription(data) {
  return _RestHelper.default.post("".concat(_RestHelper.default.getBaseUrl()).concat(urlSubscriptions), data);
}

/**
 * - Edit an existing subscription
 */
function editSubscription(subscriptionId, data) {
  return _RestHelper.default.put("".concat(_RestHelper.default.getBaseUrl()).concat(urlSubscriptions, "/").concat(subscriptionId), data);
}

/**
 * - Delete an existing subscription
 * The subscription to delete is identified by the target URI (subscriptionId).
 */
function deleteSubscription(subscriptionId) {
  return _RestHelper.default.delete("".concat(_RestHelper.default.getBaseUrl()).concat(urlSubscriptions, "/").concat(subscriptionId));
}